module.exports = __webpack_public_path__ + "static/img/new5.0d83b9c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new5.jpeg
// module id = 3hq/
// module chunks = 0